import { render, staticRenderFns } from "./SPBasicToast.vue?vue&type=template&id=ff30ff9a&scoped=true"
import script from "./SPBasicToast.vue?vue&type=script&lang=js"
export * from "./SPBasicToast.vue?vue&type=script&lang=js"
import style0 from "./SPBasicToast.vue?vue&type=style&index=0&id=ff30ff9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff30ff9a",
  null
  
)

export default component.exports